import React from 'react';
import FancyInput from "../elements/FancyInput";
import Addressify from "../elements/Addressify";
import HoneyPot from "../elements/HoneyPot";

const InternetForm = (props) => {
	
	return (
		<div className="animate-out">
			<div className="row form-row">
				<div className="col-xs-12">
					<Addressify handleSetAddress={event => props.handleSetAddress(event)} label="Address" />
				</div>
			</div>
			<div className="row form-row">
				<div className="col-sm-6 name-fields">
					<FancyInput name="first_name" maxLength="50" label="First Name" value={props.state.first_name} handleChange={event => props.handleInputChange(event)} />
					<FancyInput name="last_name" maxLength="50" label="Last Name" value={props.state.last_name} handleChange={event => props.handleInputChange(event)} />
				</div>
				<div className="col-sm-6">
					<FancyInput name="company" maxLength="50" label="Company" value={props.state.company} handleChange={event => props.handleInputChange(event)} />
				</div>
			</div>
			<HoneyPot nameField={props.honeypot} nameValue={props.state[props.honeypot]} handleChange={event => props.handleInputChange(event)} />
			<div className="row form-row">
				<div className="col-sm-6">
					<FancyInput name="email" type="email" maxLength="50" label="Email" value={props.state.email} handleChange={event => props.handleInputChange(event)} />
				</div>
				<div className="col-sm-6">
					<FancyInput name="phone" type="tel" maxLength="20" label="Phone Number" value={props.state.phone} handleChange={event => props.handleInputChange(event)} />
				</div>
			</div>
		</div>
	);
	
};

export default InternetForm;


// WEBPACK FOOTER //
// ./resources/assets/js/forms/InternetForm.js